'use strict';

const DataSetRowIdentity = {
	equal: rowsAreEqual,
	uniqBy: rowUniqueBy,
	id: rowIdentifierProperty,
};

function rowsAreEqual(rowA, rowB) {
	var idProperty = rowIdentifierProperty(rowA);
	return rowA && rowB && ((idProperty && rowA[idProperty] === rowB[idProperty]) || rowA === rowB);
}

function rowUniqueBy(row) {
	var idProperty = rowIdentifierProperty(row);
	return row && ((idProperty && row[idProperty]) || row);
}

function rowIdentifierProperty(row) {
	return row && typeof row._id !== 'undefined' && '_id';
}

export default DataSetRowIdentity;
